<template>
  <div>
    <el-descriptions size="small" direction="vertical" :column="3" border>
      <el-descriptions-item :label="$l('form_label_amzAppName') || '应用名称'">
        {{ formData.amzAppName }}
      </el-descriptions-item>
      <el-descriptions-item :label="$l('form_label_amzStoreNo') || '店铺编号'">
        {{ formData.amzStoreNo }}
      </el-descriptions-item>
      <el-descriptions-item
        :label="$l('form_label_amzStoreName') || '店铺名称'"
      >
        {{ formData.amzStoreName }}
      </el-descriptions-item>
      <el-descriptions-item
        :label="$l('form_label_marketplaceId') || '亚马逊商城ID'"
      >
        {{ formData.marketplaceId }}
      </el-descriptions-item>
      <el-descriptions-item :label="$l('form_label_taskType') || '任务类型'">
        {{ formData.taskType }}
      </el-descriptions-item>
      <el-descriptions-item :label="$l('form_label_reportType') || '报表类型'">
        {{ formData.reportType }}
      </el-descriptions-item>
      <el-descriptions-item
        :label="$l('form_label_dataStartTime') || '报告数据的开始时间'"
      >
        {{ formData.dataStartTime }}
      </el-descriptions-item>
      <el-descriptions-item
        :label="$l('form_label_dataEndTime') || '报告数据的结束时间'"
      >
        {{ formData.dataEndTime }}
      </el-descriptions-item>
      <el-descriptions-item
        :label="$l('form_label_reportId') || '亚马逊报表ID'"
      >
        {{ formData.reportId }}
      </el-descriptions-item>
      <el-descriptions-item :label="$l('form_label_createTime') || '创建时间'">
        {{ formData.createTime }}
      </el-descriptions-item>
      <el-descriptions-item :label="$l('form_label_modifyTime') || '更新时间'">
        {{ formData.modifyTime }}
      </el-descriptions-item>
      <el-descriptions-item
        :label="$l('form_label_documentId') || '亚马逊文档ID'"
      >
        <el-link
          v-if="formData.documentId"
          :underline="false"
          type="primary"
          :href="formData.documentUrl"
          target="_blank"
          style="font-size: 13px;"
        >
          {{ formData.documentId }}
        </el-link>
      </el-descriptions-item>
    </el-descriptions>

    <div class="side-frame mt-4">
      <span style="font-size: 14px; color: #606266">
        {{ $l('report_processing') || '处理结果' }}
      </span>
    </div>
    <el-descriptions size="small" direction="vertical" :column="3" border>
      <el-descriptions-item
        :label="$l('form_label_reportProcessingStatus') || '报表处理状态'"
      >
        {{ formData.reportProcessingStatus }}
      </el-descriptions-item>
      <el-descriptions-item
        :label="$l('form_label_reportProcessed') || '报表是否处理结束'"
      >
        <el-tag
          size="mini"
          :type="formData.reportProcessed === 'Y' ? 'success' : 'danger'"
        >
          {{ formData.v_reportProcessed }}
        </el-tag>
      </el-descriptions-item>
      <el-descriptions-item
        :label="$l('form_label_createReportResult') || '报表创建结果'"
        :contentStyle="{ width: '500px' }"
      >
        {{ formData.createReportResult }}
      </el-descriptions-item>
      <el-descriptions-item
        :label="$l('form_label_syncStatus') || '同步到系统的状态'"
      >
        <el-tag
          size="mini"
          :type="
            formData.syncStatus === 'Y'
              ? 'success'
              : formData.syncStatus === 'E'
              ? 'danger'
              : ''
          "
        >
          {{ formData.v_syncStatus }}
        </el-tag>
      </el-descriptions-item>
      <el-descriptions-item
        :label="$l('form_label_syncOssFile') || 'OSS同步文件'"
      >
        <el-link
          v-if="formData.syncOssFileName"
          :underline="false"
          type="primary"
          :href="formData.syncOssUrl"
          target="_blank"
          style="font-size: 13px;"
        >
          {{ formData.syncOssFileName }}
        </el-link>
      </el-descriptions-item>
      <el-descriptions-item :label="$l('form_label_syncResult') || '同步结果'">
        {{ formData.syncResult }}
      </el-descriptions-item>
    </el-descriptions>
  </div>
</template>
<script>
export default {
  props: { reportTaskRecordCode: { type: String, default: '' } },
  data() {
    return { formData: {} }
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      if (!this.reportTaskRecordCode) return
      const res = await this.$api
        .ecomAmzApiReportTaskRecordDetailApi({
          reportTaskRecordCode: this.reportTaskRecordCode,
        })
        .catch(() => null)
      this.formData = res?.body || {}

      console.log('this.formData >>', this.formData)
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame-success {
  padding: 1px 5px;
  border-left: 3px solid $color-success;
  height: 20px;
  margin-top: 3px;
  display: flex;
  align-items: center;
}

::v-deep {
  .border-top-none {
    .el-descriptions-item__label,
    .el-descriptions-item__content {
      border-top: none !important;
    }
  }
  .border-bottom-none {
    .el-descriptions-item__label,
    .el-descriptions-item__content {
      border-bottom: none !important;
    }
  }
}
</style>
